"use strict";

/* eslint-disable no-undef, func-names, no-restricted-globals, no-use-before-define */

// Define global variable.
var tincannyMediaUpload;

// Define trigger upload function.
class TincannyMediaUploadClass {
  constructor($, key) {
    this.$ = $;
    this.isIframe = window.self !== window.top;
    this.key = key || false;
    this.enableButton = true;
    this.ids = {
      parentId: 'snc-media_upload_file_wrap',
      uploadWrapperId: 'snc-media_upload_tincanny-uploader-wrapper',
      buttonWrapId: 'snc-media_upload_button_wrap',
      contentID: 'content_id'
    }, this.config = window.tincannyZipUploadData || {};
    this.addEventListeners();
  }
  getDirectory() {
    if (typeof window.top.tincannyZipUploadData === 'undefined') {
      window.top.tincannyZipUploadData = this.config;
    }
    return window.top.tincannyZipUploadData.currentDirectory || '';
  }
  setDirectory(directory) {
    if (typeof window.top.tincannyZipUploadData === 'undefined') {
      window.top.tincannyZipUploadData = this.config;
    }
    window.top.tincannyZipUploadData.currentDirectory = directory;
  }
  addEventListeners() {
    var app = this;

    // Add Listener for Uploader Events.
    document.addEventListener("tincanny-zip-uploader-event", e => {
      var detail = e.detail || {};
      if (!detail.action) {
        return;
      }
      if (parseInt(app.config.debug)) {
        console.log({
          action: 'tincanny-zip-uploader-event-media.js',
          detail: detail
        });
      }
      var data = detail.data || {};
      if (detail.action === 'registered-tincanny-module') {
        if (detail.success) {
          app.handleUploadSuccess(data);
        }
      }
      if (detail.action === 'upload-started-tincanny-zip') {
        app.setDirectory(data.directory);
      }
      if (detail.action === 'cancel-tincanny-module-upload') {
        app.handleCancelledUpload(data);
      }
    });

    // Add Click and Change Event Listeners.
    document.addEventListener('click', event => {
      if (event.target.matches('.snc-file_upload_button_wrapper button')) {
        if (!app.enableButton) {
          return;
        }
        var $parentWrapper = event.target.closest('.snc-file_upload_button_wrapper');
        var $fileInput = $parentWrapper.querySelector('input[type="file"]');
        $fileInput.click();
        $fileInput.onchange = e => {
          var $contentID = app.getElByID(app.ids.contentID);
          app.showLoading();
          app.triggerZipUploaderEvent({
            action: 'upload-tincanny-zip',
            uploadWrapperID: app.ids.uploadWrapperId,
            file: e.target.files[0],
            contentID: $contentID ? $contentID.value : ''
          });
        };
      } else if (event.target.matches('#tab-snc-library a')) {
        app.maybeCleanUpAbortedUploads(app);
      }
    });

    // Handle Aborted Uploads

    // Listen for Thickbox Close when code is triggered from iFrame or parent.
    var TBjQuery = app.isIframe ? window.parent.jQuery : app.$;
    TBjQuery("#TB_closeWindowButton, #TB_overlay").click(function () {
      app.maybeCleanUpAbortedUploads(app);
    });

    // Disable Escape Key.
    TBjQuery(document).on('keydown', function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }
  getElByID(id) {
    var $el = document.getElementById(id);
    return $el && $el !== null ? $el : false;
  }
  showLoading() {
    this.enableButton = false;
    this.show(this.ids.uploadWrapperId);
    this.hide(this.ids.buttonWrapId);
  }
  hideLoading() {
    this.enableButton = true;
    this.show(this.ids.buttonWrapId);
    this.hide(this.ids.uploadWrapperId);
    this.setDirectory('');
  }
  hide(id) {
    var $el = this.getElByID(id);
    if ($el) {
      $el.style.display = 'none';
    }
  }
  show(id) {
    var $el = this.getElByID(id);
    if ($el) {
      $el.style.display = 'block';
    }
  }
  setAttribute(selector, attribute, value) {
    var $el = document.querySelector(selector);
    if ($el) {
      $el.setAttribute(attribute, value);
    }
  }
  triggerZipUploaderEvent(data) {
    var event = new CustomEvent('tincanny-zip-uploader-event', {
      detail: data
    });
    document.dispatchEvent(event);
  }
  handleUploadSuccess(data) {
    this.setDirectory('');
    var $parent = this.getElByID(this.ids.parentId);
    if (!$parent) {
      return;
    }
    var $noTab = $parent.querySelector('#no_tab');
    var $noRefresh = $parent.querySelector('#no_refresh');
    if ($noTab) {
      if ($noRefresh) {
        //self.parent.window.wp.tccmb_content($('#ele_id').val());
        self.parent.tb_remove();
      } else {
        window.parent.location = window.parent.location.href;
      }
    }

    // Handle Visual Composer.
    if (this.key && this.key !== 'undefined') {
      this.setAttribute('#vc_properties-panel .vc-snc-trigger input', 'value', data.id);
      this.setAttribute('#vc_properties-panel .vc-snc-name input', 'value', data.title);
      trigger_vc_snc_mode();
    } else {
      var $embedInfo = document.querySelector('.snc-embed_information');
      if (null !== $embedInfo) {
        $embedInfo.style.display = 'block';
        this.hide(this.ids.parentId);
      }
      this.setAttribute('a.delete-media', 'data-item_id', data.id);
      this.setAttribute('input#item_id', 'value', data.id);
      this.setAttribute('input#item_title', 'value', data.title);
    }
  }
  handleCancelledUpload() {
    this.hideLoading();
  }
  maybeCleanUpAbortedUploads(app) {
    var directory = app.getDirectory();
    if (directory === '') {
      return;
    }
    var config = window.top.tincannyZipUploadData;
    app.setDirectory('');
    jQuery.ajax({
      method: "POST",
      data: {
        'action': 'cancel-tincanny-module-upload',
        'directory': directory,
        'status': 'abort',
        'security': config.nonce
      },
      url: config.rest_url + config.rest_namespace,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('X-WP-Nonce', config.rest_nonce);
      }
    });
  }
}
jQuery(document).ready($ => {
  var key = false; // review test VC to understand this setup.
  tincannyMediaUpload = new TincannyMediaUploadClass($, key);
});